(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentReviewControllers')
        .directive('preFinalRatings', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                assessment: '=',
                risk: '=',
                onUpdate: '&',
                onRatingChanged: '&',
                readOnly: '&',
                title: '@',
                layoutRatio: '=?',
            },
            template: '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$scope', 'commonRiskSelfAssessmentService', 'riskSelfAssessmentReviewService',
                function ($scope, commonRiskSelfAssessmentService, riskSelfAssessmentReviewService) {

                    $scope.readOnly = !!$scope.readOnly();

                    $scope.getTemplateUrl = function () {
                        if ($scope.risk.RiskLevel.IsKeyRisk) return '/app/Main/riskSelfAssessment/review/preFinalRatings.Key.tpl.html';
                        if ($scope.risk.RiskLevel.IsTopRisk) return '/app/Main/riskSelfAssessment/review/preFinalRatings.Top.tpl.html';

                        return '';
                    };

                    // Set Probability Rating
                    $scope.setProbabilityRating = function (criteria) {
                        $scope.assessment.PreFinalProbabilityCode = criteria.Code;
                        $scope.assessment.PreFinalIsOverriden = false;

                        computeOverallCriteria();
                    };

                    // Set Severity Rating
                    $scope.setSeverityRating = function (criteria) {
                        $scope.assessment.PreFinalSeverityCode = criteria.Code;
                        $scope.assessment.PreFinalIsOverriden = false;

                        computeOverallCriteria();
                    };

                    // Set Mitigation Rating
                    $scope.setMitigationRating = function (criteria) {
                        $scope.assessment.PreFinalMitigationCode = criteria.Code;
                        $scope.assessment.PreFinalIsOverriden = false;

                        computeOverallCriteria();
                    };

                    // Set Overall Rating
                    $scope.setOverallRating = function (criteria) {
                        $scope.assessment.PreFinalOverallCode = criteria.Code;
                        $scope.assessment.PreFinalIsOverriden = true;

                        $scope.onRatingChanged();
                    };

                    $scope.init = function () {

                        commonRiskSelfAssessmentService
                            .getAllCriteriasByTypeAndByCode()
                            .then(function (criterias) {
                                $scope.probabilityCriterias = criterias['Probability'];
                                $scope.mitigationCriterias  = criterias['Mitigation'];
                                $scope.severityCriterias    = criterias['Severity'];
                                $scope.overallCriterias     = criterias['Overall'];
                                $scope.naCriteria           = commonRiskSelfAssessmentService.getNACriteria();

                                $scope.updateCriterias();
                            });

                        // Layout Ratio
                        if (_.isUndefined($scope.layoutRatio)) $scope.layoutRatio = {};
                        $scope.layout                  = {};
                        $scope.layout.column           = $scope.layoutRatio.column || 'col-sm-12';
                        $scope.layout.yearColumnSize   = $scope.layoutRatio.yearColumnSize || '3';
                        $scope.layout.ratingColumnSize = $scope.layoutRatio.ratingColumnSize || '9';
                        $scope.layout.hideIcon         = _.isBoolean($scope.layoutRatio.hideIcon) ? $scope.layoutRatio.hideIcon : false;
                        $scope.layout.hideLabels       = _.isBoolean($scope.layoutRatio.hideLabels) ? $scope.layoutRatio.hideLabels : false;
                    };

                    $scope.updateCriterias = function () {
                        if (!$scope.probabilityCriterias) return;
                        if (!$scope.mitigationCriterias) return;
                        if (!$scope.severityCriterias) return;
                        if (!$scope.overallCriterias) return;

                        $scope.probabilityCriteria = $scope.probabilityCriterias[$scope.assessment.PreFinalProbabilityCode] || $scope.naCriteria;
                        $scope.mitigationCriteria  = $scope.mitigationCriterias[$scope.assessment.PreFinalMitigationCode] || $scope.naCriteria;
                        $scope.severityCriteria    = $scope.severityCriterias[$scope.assessment.PreFinalSeverityCode] || $scope.naCriteria;
                        $scope.overallCriteria     = $scope.overallCriterias[$scope.assessment.PreFinalOverallCode] || $scope.naCriteria;
                    };

                    function computeOverallCriteria() {

                        commonRiskSelfAssessmentService
                            .computeOwnerOverallCriteria(
                                $scope.assessment.PreFinalSeverityCode,
                                $scope.assessment.PreFinalProbabilityCode,
                                $scope.assessment.PreFinalMitigationCode
                            )
                            .then(function (computedOverallCriteria) {
                                $scope.assessment.PreFinalComputedOverallCode = computedOverallCriteria.Code;
                                $scope.assessment.PreFinalOverallCode = computedOverallCriteria.Code;

                                $scope.onRatingChanged();

                                $scope.updateCriterias();
                            });
                    }

                    function updateKeyRiskPreFinalAssessment() {
                        return riskSelfAssessmentReviewService
                            .updateKeyRiskPreFinalAssessment({Risk: $scope.risk, Assessment: $scope.assessment})
                            .then(function (updRiskToReview) {
                                $scope.assessment = updRiskToReview.Assessment;
                                $scope.updateCriterias();
                            });
                    }
                }],
            link: function (scope, elem, attrs) {

                scope.init();

                scope.$watch('assessment', function (newValue) {
                    if (newValue) {
                        scope.updateCriterias();
                    }
                }, true);
            }
        }
    }
})();
